<h2 mat-dialog-title>Afdeling ændret</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <p class="margin--top-m">Der er ændret afdeling på brugeren, ønsker du også at opdatere aftalenummer?</p>
</div>
<mat-dialog-actions>
  <button mat-raised-button (click)="onNoClick()">Nej</button>
  <button mat-raised-button color="primary" (click)="onYesClick()">Ja</button>
</mat-dialog-actions>
